import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Navigation } from "../components/Navigation";
import { useNoindex } from "../hooks/useNoindex";

/**
 * 404 fallback page. Every unmatched route lands here (see App.js
 * `<Route path="*" element={<NotFoundPage />} />`). We emit a `noindex` meta
 * tag so Google removes it from the index if it ever crawls a bogus URL like
 * `/accedi` or `/fr/about` — this fixes the Soft-404 warnings in Search
 * Console.
 */
export default function NotFoundPage() {
  useNoindex();

  useEffect(() => {
    document.title = "Pagina non trovata (404) | Edicola Cerasuolo";
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <Navigation />
      <main className="max-w-3xl mx-auto px-4 py-24 text-center" data-testid="not-found-page">
        <div className="text-7xl font-black text-gray-300 mb-4">404</div>
        <h1 className="text-3xl font-bold text-gray-900 mb-3">
          Pagina non trovata
        </h1>
        <p className="text-gray-600 mb-8 max-w-md mx-auto">
          La pagina che cercavi non esiste o è stata spostata. Torna alla home o esplora il nostro catalogo di modellini.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Link
            to="/"
            className="inline-block px-6 py-3 bg-green-600 hover:bg-green-700 text-white font-semibold rounded-lg transition"
            data-testid="not-found-home-btn"
          >
            Torna alla Home
          </Link>
          <Link
            to="/prodotti"
            className="inline-block px-6 py-3 bg-white hover:bg-gray-100 text-gray-900 font-semibold rounded-lg border border-gray-300 transition"
            data-testid="not-found-shop-btn"
          >
            Sfoglia i prodotti
          </Link>
        </div>
      </main>
    </div>
  );
}
